var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"analysis-page"},[_c('div',{attrs:{"id":"analysis"}},[(_vm.product && !_vm.loading)?_c(_vm.renderer,{tag:"component",attrs:{"product":_vm.product}}):_c('AnalysisSkeleton')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }